import PropTypes from 'prop-types';
import ArticleArcPreview from '@/apps/ip-creator/components/ArticleArcPreview';
import FactAnchorPreview from '@/apps/ip-creator/components/FactAnchorPreview';
import HotPotPreview from '@/apps/ip-creator/components/HotPotPreview';
import ScriptArcPreview from '@/apps/ip-creator/components/ScriptArcPreview';
import SeedPlanPreview from '@/apps/ip-creator/components/SeedPlanPreview';
import TopicLensPreview from '@/apps/ip-creator/components/TopicLensPreview';

const previewByEntityType = {
  articleArc: ArticleArcPreview,
  factAnchor: FactAnchorPreview,
  hotPot: HotPotPreview,
  scriptArc: ScriptArcPreview,
  seedPlan: SeedPlanPreview,
  topicLens: TopicLensPreview,
};

const AgentArtifactPreview = ({ artifact }) => {
  const Preview = previewByEntityType[artifact.entityType];
  if (!Preview || !artifact?.data || typeof artifact.data !== 'object') {
    return null;
  }
  return <Preview record={artifact.data} />;
};

AgentArtifactPreview.propTypes = {
  artifact: PropTypes.shape({
    data: PropTypes.shape({}),
    entityType: PropTypes.string,
  }).isRequired,
};

export default AgentArtifactPreview;
